import React from 'react';
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
} from '@chakra-ui/react';
import {
  chakra,
  Container,
  VStack,
  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function PEducation() {
  const [data, setData] = React.useState([]);
  const [islateral, setLateral] = React.useState("");
  React.useEffect(() => {
    axios.get('https://glb-api.onrender.com/student/education',{params:{token:localStorage.getItem("token")}})
    .then(res => {
      console.log(res.data);

      setData(res.data);
      if(data.highestDegree?.isLateral)
        setLateral("Yes");
      else
        setLateral("No")
    })
    .catch(err => {
      console.log(err);
      // setError('Failed to fetch the details right now.')
    })
  }, [])
  return (
    <>
      <div>
        <Box>
          <VStack gap={10}>
          <Card variant={'unstyled'} boxShadow="none" width={'100%'} >
            <CardBody>
              <Box bg="white" shadow="md" borderRadius="md" p="6" width="100%">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                    Education Details
                  </Heading>
                  <Button
                    leftIcon={<EditIcon />}
                    marginTop={'4px'}
                    colorScheme="blue"
                    variant="outline"
                    size={'lg'}
                    display={{ base: 'none', md: 'inline-flex' }}
                    fontSize={{ base: '', md: '3xl' }}
                    href={'#'}
                  >
                    Edit info
                  </Button>
                </Flex>
              </Box>

              <Box className="mt-10">
                <Center>
                  <Box width={'100%'}>
                    <Card variant={'elevated'}>
                      <CardHeader>
                        <Box bg="white" p={5} borderRadius="md">
                          <Heading as="h2" textAlign="left" size={{ base: 'md', md: 'xl' }} mb={3}>
                            Current/Most Recent Course
                          </Heading>

                          <HStack spacing={10} marginTop={'20px'}>
                            <Box flex={1}>
                              <Heading as="h3" size="lg" mb={2}>
                                B.Tech
                              </Heading>
                              <Text
                                fontSize={{ base: 'xl', md: '' }}
                                fontWeight="bold"
                                color="gray.600"
                              >
                                2019-2023
                              </Text>
                            </Box>
                            <Box>
                              <Text
                                fontSize={{ base: '', md: '3xl' }}
                                fontWeight="bold"
                                color="green.500"
                              >
                                GPA 3.8
                              </Text>
                            </Box>
                          </HStack>
                        </Box>

                        <Divider marginTop={'10px'} />
                      </CardHeader>

                      <CardBody>
                        <SimpleGrid columns={2} spacingX="0px">
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>NAME:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.instituteName}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>Institute ID:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.instituteID}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>start</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.tenure.start}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>end</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.tenure.end}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>degree:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.degree}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>branch:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.highestDegree?.branch}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>lateral entry:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{islateral}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>Contact Details:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>+91-3243276186</Text>
                          </Box>
                        </SimpleGrid>
                      </CardBody>
                    </Card>
                  </Box>
                </Center>
              </Box>
            </CardBody>
          </Card>

          <Card  variant={'unstyled'} boxShadow="none" width={'100%'}>
            <CardBody>
              <Box className="">
                <Center>
                  <Box width={'100%'}>
                    <Card variant={'elevated'}>
                      <CardHeader>
                        <Box bg="white" p={5} borderRadius="md">
                          <Heading as="h2" textAlign="left" size={{ base: 'xl', md: '' }} mb={3}>
                            Previous Educations
                          </Heading>

                          <HStack spacing={10} marginTop={'20px'}>
                            <Box flex={1}>
                              <Heading as="h3" size="lg" mb={2}>
                                Class XII
                              </Heading>
                              <Text
                                fontSize={{ base: 'xl', md: '' }}
                                fontWeight="bold"
                                color="gray.600"
                              >
                                2019-2023
                              </Text>
                            </Box>
                            <Box>
                              <Text
                                fontSize={{ base: '', md: '3xl' }}
                                fontWeight="bold"
                                color="green.500"
                              >
                                89.5%
                              </Text>
                            </Box>
                          </HStack>
                        </Box>

                        <Divider marginTop={'10px'} />
                      </CardHeader>

                      <CardBody>
                        <SimpleGrid columns={2} spacingX="0px">
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>NAME:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.name}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>start</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.tenure.start}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>end</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.tenure.end}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>board</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.boead}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>stream</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.stream}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>aggregate</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.twelth?.aggregate.toString()}</Text>
                          </Box>
                        </SimpleGrid>
                      </CardBody>
                    </Card>
                  </Box>
                </Center>
              </Box>
            </CardBody>
          </Card>

          <Card  variant={'unstyled'} boxShadow="none" width={'100%'}>
            <CardBody>
              <Box className="">
                <Center>
                  <Box width={'100%'}>
                    <Card variant={'elevated'}>
                      <CardHeader>
                        <Box bg="white" p={5} borderRadius="md">
                          <Heading as="h2" textAlign="left" size={{ base: 'xl', md: '' }} mb={3}>
                            Previous Educations
                          </Heading>

                          <HStack spacing={10} marginTop={'20px'}>
                            <Box flex={1}>
                              <Heading as="h3" size="lg" mb={2}>
                                Class X
                              </Heading>
                              <Text
                                fontSize={{ base: 'xl', md: '' }}
                                fontWeight="bold"
                                color="gray.600"
                              >
                                2019-2023
                              </Text>
                            </Box>
                            <Box>
                              <Text
                                fontSize={{ base: '', md: '3xl' }}
                                fontWeight="bold"
                                color="green.500"
                              >
                                92%
                              </Text>
                            </Box>
                          </HStack>
                        </Box>

                        <Divider marginTop={'10px'} />
                      </CardHeader>

                      <CardBody>
                        <SimpleGrid columns={2} spacingX="0px">
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>NAME:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.tenth?.name}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>start</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.tenth?.tenure.start}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>end</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.tenth?.tenure.end}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>board</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.tenth?.board}</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>aggregate</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: '', md: '3xl' }}>{data.tenth?.aggregate.toString()}</Text>
                          </Box>
                        </SimpleGrid>
                      </CardBody>
                    </Card>
                  </Box>
                </Center>
              </Box>
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </div>
  </>
  );
}
